import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { IdleTimeoutService } from './core/auth/idle-timeout.service';
import { GlobalLoaderComponent } from './shared/components/global-loader/global-loader.component';
import { AppOffline } from './shared/components/app-offline/app-offline';
import { ConnectionCheck } from './shared/services/connection-check';
import { RumAuditService } from './shared/services/rum-audit.service';

@Component({
  selector: 'adb-root',
  imports: [RouterOutlet, GlobalLoaderComponent, AsyncPipe, AppOffline],
  templateUrl: './app.html',
})
export class App {
  readonly connectionCheck = inject(ConnectionCheck);
  constructor() {
    inject(AuthService).init();
    inject(RumAuditService).init();
    inject(IdleTimeoutService).init();
  }
}
